import { Country } from '../types';
import countryGroups from '../../../fixtures/countryGroups';

declare let offerItems: any;

/**
 *
 */
export default (allCountries: Array<Country>, destination: string, countryCode: string, tariff: string) => {
    const selectedCountryString = allCountries.find((e: Country) => (e.countryCode === countryCode)).name;

    switch (destination) {
        case 'inForeignCountry':
            destination = 'inForeignCountries';
            break;

        case 'toForeignCountry':
            destination = 'toForeignCountries';
            break;

        case 'inForeignCountrySmartDevice':
            destination = 'inForeignCountriesSmartDevice';
            break;

        default:
            // eslint-disable-next-line no-console
            console.log('Error Destination not set!');
    }

    const countryRow = getCountryRow(selectedCountryString, destination);

    return getFilteredOptions(destination, selectedCountryString, countryRow, tariff);
};

const getCountryRow = (country, destination) => {
    let row = 'Other'; // Todo: maybe return "Other" to catch all countries not mentioned in the list

    if (typeof destination === 'undefined') {
        destination = 'inForeignCountries';
    }

    // Smart tech stuff will fall under inForeignCountries
    const groupsArray = destination === 'toForeignCountries' ? countryGroups.toForeignCountries : countryGroups.inForeignCountries;

    for (const group in groupsArray) {
        if (Object.prototype.hasOwnProperty.call(groupsArray, group) && groupsArray[group].includes(country)) {
            row = group;
            break;
        }
    }

    return row;
};

const getFilteredOptions = (destination, country, countryRow, tariff) => {
    switch (tariff) {
        /*
        case 'familyCard':
            tariff = 'RedTarif';
            break;
        */
        case 'gigaMobilOrGigaMobilYoung':
            tariff = 'RedYoungTarif';
            break;
        case 'redOrYoung':
            tariff = 'RedYoungTarif';
            break;
        case 'familyCard':
            tariff = 'FamilyCardTarif';
            break;
        case 'smart':
            tariff = 'SmartTarif';
            break;
        case 'easy':
            tariff = 'EasyTarif';
            break;
        case 'other':
            tariff = 'other';
            break;
    }

    let filteredElementList = offerItems.filter(
        e => (e.optCountryRow === country && e.optTariffOption === tariff && e.optDestination === destination),
    );

    if (filteredElementList.length === 0) {
        filteredElementList = offerItems.filter(
            e => (e.optCountryRow === countryRow && e.optTariffOption === tariff && e.optDestination === destination),
        );
    }

    if (filteredElementList.length === 0) {
        filteredElementList = offerItems.filter(
            e => e.optCountryRow === 'other' && e.optTariffOption === tariff && e.optDestination === destination,
        );
    }

    return filteredElementList;
};
